(function () {
	document.addEventListener('DOMContentLoaded', () => {
		const groups = document.querySelectorAll('.gallery-lightbox-group');

		groups.forEach((group) => {
			const childGalleries = Array.from(
				group.querySelectorAll('.gallery-lightbox'),
			);

			if (!childGalleries.length) {
				return;
			}

			const galleryDatas = childGalleries.map((gallery) => ({
				gallery,
				images: JSON.parse(
					decodeURIComponent(gallery.dataset.images || '[]') || '[]',
				),
			}));

			const combinedImages = galleryDatas.reduce(
				(acc, item) => acc.concat(item.images),
				[],
			);

			galleryDatas.forEach((item, galleryIndex) => {
				const imgs = Array.from(item.gallery.querySelectorAll('img'));

				imgs.forEach((img, imageIndex) => {
					img.addEventListener('click', () => {
						const startIndex =
							galleryDatas
								.slice(0, galleryIndex)
								.reduce((sum, prev) => sum + prev.images.length, 0) +
							imageIndex;

						window.Lightbox?.open({
							images: combinedImages,
							startIndex,
						});
					});
				});
			});
		});
	});
})();
